import { LineChart } from "@/components/ui/line-chart"

// Two-series line chart. AI vs Human is the canonical use case but the
// labels are configurable so this component is also used wherever we
// want to compare two cohorts over time on the same axis.
//
// Backed by the generic <LineChart> primitive in line-chart.tsx — kept
// here as a stable, named wrapper so existing callers don't have to
// rewire props.

type Props = {
  dates: string[]
  seriesA: (number | null)[]
  seriesB: (number | null)[]
  labelA?: string
  labelB?: string
  colorA?: string
  colorB?: string
  height?: number
  formatY?: (n: number) => string
  formatTooltip?: (n: number) => string
}

export function DualLineChart({
  dates,
  seriesA,
  seriesB,
  labelA = "A",
  labelB = "B",
  colorA = "#ef4444",
  colorB = "#facc15",
  height = 240,
  formatY,
  formatTooltip,
}: Props) {
  return (
    <LineChart
      dates={dates}
      height={height}
      formatY={formatY}
      formatTooltip={formatTooltip ? (n) => formatTooltip(n) : undefined}
      series={[
        { id: labelA, label: labelA, data: seriesA, color: colorA },
        { id: labelB, label: labelB, data: seriesB, color: colorB },
      ]}
    />
  )
}
